import { useTranslate } from '@tolgee/react';

import { usePremiumTestPrepPlaywall } from '../providers/PremiumTestPrepPlaywallProvider/PremiumTestPrepPlaywallProvider';

/**
 * Returns the tooltip text shown next to the 👑 (EnterprisePlanIcon)
 * in test prep surfaces. Copy varies by plan:
 *
 * - School Plan users: celebratory "you have access" message
 * - Everyone else: "School Plan feature, 3 free lessons" upgrade nudge
 */
export function useCrownTooltipText(): string {
  const { t } = useTranslate();
  const { isNotEnterprise } = usePremiumTestPrepPlaywall();

  if (isNotEnterprise) {
    return t(
      'TestPrep.CrownTooltip',
      'School Plan feature. Everyone gets three free lessons — upgrade for unlimited access.',
    );
  }

  return t(
    'TestPrep.CrownTooltip.SchoolPlan',
    'Unlocked — you are on the school plan and have access to all test preps.',
  );
}
